import { useFlag } from '@acre/utils'

// Single source for Helmet's titleTemplate and defaultTitle so every PageMeta instance
// switches brand with the rebrand flag together.
export const useBrandedTitleTemplate = () => {
  const isScoreRebrandCP = useFlag('feature.score_rebrand_cp', false)

  return isScoreRebrandCP ? '%s - Score. Client Portal' : '%s - Acre Client Portal'
}

export const useDefaultBrandedTitle = () => {
  const isScoreRebrandCP = useFlag('feature.score_rebrand_cp', false)

  return isScoreRebrandCP ? 'Score. Client Portal' : 'Acre Client Portal'
}
